export const DEVICE_TYPES = {
  MOBILE: (width: number) => width < 600,
  TABLET: (width: number) => width >= 600 && width <= 1100,
  DESKTOP: (width: number) => width > 1100,
}
